import PaiMenuItem from 'features/ui/base-components/pai-menu-item';
import PaiSelect from 'features/ui/base-components/pai-select';
import { Folder } from 'features/lead/lead-management/lead-manage-questionnaires/lead-manage-questionnaires.types';
import React from 'react';
import { BasicActionDialog } from '../../../ui/base-dialogs';

interface Props {
  open: boolean;
  allFolders: Folder[];
  selectedFolder: string;

  handleClose(): void;

  handleProceed(): void;

  handleSelectedFolderChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

const MoveQuestionnaireDialog: React.FC<Props> = ({ open, allFolders, selectedFolder, handleClose, handleProceed, handleSelectedFolderChange }) => {
  return (
    <BasicActionDialog
      dialogTitle={'Fragebogen verschieben'}
      maxWidth={'xs'}
      cancelButtonText={'Abbrechen'}
      proceedButtonText={'Ok'}
      open={open}
      handleClose={handleClose}
      handleProceed={handleProceed}
      proceedButtonDisabled={selectedFolder.trim() === ''}
    >
      <PaiSelect value={selectedFolder} label={'Wählen Sie den Zielordner aus'} onChange={handleSelectedFolderChange}>
        {allFolders.map((folder) => (
          <PaiMenuItem key={folder.id} value={folder.id}>
            {folder.name}
          </PaiMenuItem>
        ))}
      </PaiSelect>
    </BasicActionDialog>
  );
};

export default MoveQuestionnaireDialog;
